module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("There are so many people I would like to thank for bringing my story to publication that it is really impossible to name them all, but some stand out and so to them I would like to give my special thanks: Philip Appleby, for his patience and unfailing support – this book would have been impossible without him; Andrew Lownie, my agent, for believing in this project; Rupert Lancaster, Kate Miles and all the team at Hodder and Stoughton; all of the researchers and writers who have worked with me over the years, in particular Danielle Fox and Adrian Weale; my friends and supporters Ray Appleby, David Breuer-Weil and Alan James; Judith Hassan and all the staff at the Hendon Holocaust Centre; Chris Brassett; Jill Pivnik, my sister-in-law and Mei Trow, my able ghost writer who has brought my memories to life. But most especially I should thank all who have not been with me since I was a boy; my mother and father, my brothers and sisters and all my friends from Bedzin. They gave me the strength to carry on.")]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sam Pivnik")])]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("I would like to thank four people in particular for their help on this book. First and foremost – as always – my wife Carol, who has spent many hours typing the manuscript, even with a dislocated elbow; my son, Taliesin, who – again, as always – was an indefatigable researcher, gentle critic and, on this occasion, back-up typist; Greta Hofmann, for her indispensable translation work from various German texts; and Bryan Jackson, for the use of his extensive Holocaust library.")]), _vm._v(" "), _c('p', {
    staticClass: "ausig"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("M.J.T.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1-cen"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Picture Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_vm._v("Author’s collection: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo1#ph1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo2#ph2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo3#ph3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo4#ph4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo5#ph5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo7#ph7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo19#ph19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo22#ph22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo23#ph23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo24#ph24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo25#ph25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo26#ph26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo27#ph27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo28#ph28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo29#ph29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo30#ph30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo31#ph31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo32#ph32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo33#ph33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(". Aish UK: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo35#ph35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo37#ph37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo38#ph38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(". akg-images: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo10#ph10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo12#ph12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo20#ph20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(". Getty Images: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo9#ph9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo11#ph11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo16#ph16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" (photo David Clapp). Courtesy of Bernd Janssen: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo34#ph34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(". ©Estate of Mieczysław Ko"), _c('span', {
    staticClass: "epub-accent"
  }, [_vm._v("ś")]), _vm._v("cielniak: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo17#ph17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(". Adrian Weale: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo14#ph14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo15#ph15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo36#ph36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo39#ph39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(". Yad Vashem The Holocaust Martyrs’ and Heroes’ Remembrance Authority: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo6#ph6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo8#ph8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo13#ph13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(". United States Holocaust Memorial Museum, Washington DC: "), _c('span', {
    attrs: {
      "href": "#/xhtml/photo18#ph18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Every reasonable effort has been made to trace the copyright holders, but if there are any errors or omissions, Hodder & Stoughton will be pleased to insert the appropriate acknowledgement in any subsequent printings or editions.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1259d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0